<template>
  <div class="site-shell">
    <SiteHeader />
    <main>
      <section v-if="publicPageError" class="public-error-banner" role="status">
        {{ publicPageError }}
      </section>
      <PageMasthead />
      <SearchResultsPanel />
      <router-view />
    </main>
    <SiteFooter />
    <AuthModals ref="authModals" />
    <ContactUsModal />
  </div>
</template>

<script>
import frontCommon from '../mixins/frontCommon'
import SiteHeader from '../components/layout/SiteHeader.vue'
import SiteFooter from '../components/layout/SiteFooter.vue'
import PageMasthead from '../components/layout/PageMasthead.vue'
import SearchResultsPanel from '../components/layout/SearchResultsPanel.vue'
import AuthModals from '../components/auth/AuthModals.vue'
import ContactUsModal from '../components/auth/ContactUsModal.vue'

export default {
  name: 'MainLayout',
  components: {
    SiteHeader,
    SiteFooter,
    PageMasthead,
    SearchResultsPanel,
    AuthModals,
    ContactUsModal
  },
  mixins: [frontCommon],
  provide() {
    return { front: this }
  }
}
</script>
